import { useCallback, useEffect, useState } from "react";
import handleApiError from "../../hooks/handleApiError";
import client from "../client";
export default function useFetchAcademicSessions() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const request = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await client.get("/calendar/academic-sessions");
      setData(data?.data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  }, []);

  useEffect(() => {
    request();
  }, [request]);

  return [data, loading];
}
